var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticStyle:{"padding-bottom":"20px"}},[_vm._v(_vm._s(_vm.$route.meta.fullname))]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }